import React from "react";
import { useAccess } from "../contexts/AccessContext";
import AccessGuard from "./AccessGuard";

/**
 * RequireAccess
 * Envuelve una ruta y valida el acceso dinámico basado en sectionId.
 * El aviso de "sin acceso" y la protección anti-bucle (si la home calculada
 * es la propia ruta actual) viven en `AccessGuard`, compartido con otros
 * guards que no deciden por sectionId (ver `RequireNotFieldVendor`).
 */
const RequireAccess = ({ sectionId, children }) => {
  const { canAccess, loading } = useAccess();

  return (
    <AccessGuard loading={loading} denied={!canAccess(sectionId)}>
      {children}
    </AccessGuard>
  );
};

export default RequireAccess;
